import store from '@/store';
import { api } from '@/utils/api';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSalesTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        api
          .get(`/SalesTypes/GetByPagination/${businessID}`, {
            params,
          })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Sales Types list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchSalesType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID || store.state.user.id;

        if (!userID) {
          console.error('User ID not found in store');
          return Promise.reject(new Error('User ID not found. Please login again.'));
        }

        api
          .get(`/SalesTypes/LoadSelectedData/${businessID}?id=${id}&userID=${userID}`)
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              console.error('Error occurred ---> :', response.data);
              reject('Error fetching SalesType data');
            }
          })
          .catch((error) => {
            console.error('Error occurred ---> :', error);
            reject(error);
          });
      });
    },
    addSalesType(ctx, salesTypeData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id;

      if (!userID) {
        console.error('User ID not found in store');
        return Promise.reject(new Error('User ID not found. Please login again.'));
      }

      // Prepare payload with required fields
      const payload = {
        name: salesTypeData.name || '',
        code: salesTypeData.code || '',
        prefix: salesTypeData.prefix || '',
        isActive: salesTypeData.isActive !== undefined ? salesTypeData.isActive : true,
      };

      return new Promise((resolve, reject) => {
        api
          .post(`/SalesTypes/Save/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error('Add Sales Type Error:', error);
            reject(error);
          });
      });
    },
    editSalesType(ctx, salesTypeData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id;

      if (!userID) {
        console.error('User ID not found in store');
        return Promise.reject(new Error('User ID not found. Please login again.'));
      }

      // Prepare payload with required fields
      const payload = {
        name: salesTypeData.name || '',
        code: salesTypeData.code || '',
        prefix: salesTypeData.prefix || '',
        isActive: salesTypeData.isActive !== undefined ? salesTypeData.isActive : true,
      };

      return new Promise((resolve, reject) => {
        api
          .post(`/SalesTypes/Save/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error('Edit SalesType Error --->:', error);
            reject(error);
          });
      });
    },
    deleteSalesType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .delete(`/SalesTypes/Delete/${id}/${businessID}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    setSalesTypeStatus(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID || store.state.user.id;

        if (!userID) {
          console.error('User ID not found in store');
          return Promise.reject(new Error('User ID not found. Please login again.'));
        }

        api
          .post(`/SalesTypes/SetStatus/${businessID}?id=${id}&isActive=${status}&userID=${userID}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    exportSalesTypes(ctx) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/SalesTypes/Export/${businessID}`, {
            responseType: 'blob',
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error('Export SalesTypes Error:', error);
            reject(error);
          });
      });
    },
  },
};
